<template>

  <div class="bottom" v-if="content">
    <mu-card v-if="content && isDefaultView === true" id="personalizedPanel" class="bottom" @click.native="showVideo()">
      <mu-row>
        <mu-col
          width="30"
          desktop="15"
          tablet="30"
          style="position:relative;"
          v-bind:style="{backgroundImage:  `url('${content.thumbImage}')` , height: imageHeight + 'px'}"
          class="image">
        </mu-col>
        <mu-col width="70" desktop="85" tablet="70" class="calcHeight">
          <mu-card-text>
            <mu-flexbox align="center" wrap="allow" justify="center">
              <mu-flexbox-item>
                <div class="title">Personalised for you</div>
                <div class="summaryTitle">{{content.summaryTitle}}</div>
                <div class="subTitle">{{content.subTitle}}</div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-card-text>
        </mu-col>
      </mu-row>
    </mu-card>
    <mu-card v-if="content && isVideoVisible === true" id="continueWatchingPanel" class="bottom"
             @click.native="showVideo()">
      <mu-row>
        <mu-col
          width="30"
          desktop="15"
          tablet="30"
          style="position:relative;"
          v-bind:style="{backgroundImage:  `url('${course.image_url}')` , height: imageHeight + 'px'}"
          class="image">
        </mu-col>
        <mu-col width="70" desktop="85" tablet="70" class="calcHeight">
          <mu-card-text>
            <mu-flexbox align="center" wrap="allow" justify="center">
              <mu-flexbox-item>
                <div class="title">Continue learning</div>
                <div class="summaryTitle">Click here once you have finished watching this video</div>
                <div class="subTitle">Continue to this weeks's module</div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-card-text>
        </mu-col>
      </mu-row>
    </mu-card>

    <!-- Has tab conditions -->
    <div v-if="isVideoVisible && (content.intl_language_video !== '' && content.intl_language_video !== null)">
      <iframe-video-player v-if="activeTab === 'local'" :src="content.local_language_video"></iframe-video-player>
      <iframe-video-player v-if="activeTab === 'intl'" :src="content.intl_language_video"></iframe-video-player>
    </div>

    <div v-else>
      <!-- Just English and no language personalization -->
      <iframe-video-player
        v-if="isVideoVisible && content"
        :src="content.local_language_video">
      </iframe-video-player>
    </div>

    <mu-tabs v-if="content.language_id !== null && content.intl_language_video !== '' && isVideoVisible"
             :value="activeTab" @change="handleTabChange">
      <mu-tab value="intl" :title="content.language"></mu-tab>
      <mu-tab value="local" :title="content.local_language"></mu-tab>
    </mu-tabs>
  </div>
</template>
<script>

  import LessonApi from '../../../api/Lessons'

  import IframeVideoPlayer from "../../IframeVideoPlayer/IframeVideoPlayer.vue";

  export default {
    components: {
      IframeVideoPlayer
    },
    name: 'lesson-personalised-panel',
    props: {
      courseId: {
        type: Number,
        required: true
      },
      course: {
        type: Object,
        default: {}
      }
    },
    data() {
      return {
        isDefaultView: true,
        isVideoVisible: false,
        content: null,
        imageHeight: 0,
        activeTab: 'local'
      }
    },
    watch: {
      'isVideoVisible': function () {
        let self = this;
        self.$nextTick(function () {
          self.setImageHeight();
        })
      }
    },
    mounted() {
      let self = this;
      $(window).resize(function () {
        self.setImageHeight();
      });
      LessonApi.getPersonalizedContentForLesson(self.courseId)
        .then(function (response) {

          if(response.data.length > 0) {
            self.content = response.data[0];


            if (self.content.intl_language_video !== "" || self.content.intl_language_video !== null) {
              self.activeTab = 'intl'
            }
            self.setImageHeight();
            self.$nextTick(function () {
              self.setImageHeight();
            }, 300)
          }


        })
    },
    methods: {
      showVideo() {
        let self = this;
        self.isDefaultView = !self.isDefaultView;
        if (self.isDefaultView === false) {
          self.isVideoVisible = true;
          self.$emit('isMainVideoVisible', false);
        }
        else {
          self.isVideoVisible = false;
          self.$emit('isMainVideoVisible', true);
        }
      },
      setImageHeight() {
        let self = this;
        let imageHeight = $('.calcHeight');
        self.imageHeight = imageHeight.outerHeight(true);
      },
      handleTabChange(val) {
        let self = this;
        self.activeTab = val;
      }
    }
  }
</script>
<style lang="less" scoped>
  @personalizedColor: #0179d5;
  #personalizedPanel, #continueWatchingPanel {
    background: @personalizedColor;
    cursor: pointer;
    > * {
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    .subTitle, .summaryTitle {
      color: white;
    }

    .title {
      font-size: 20px;
      text-transform: uppercase;
      color: fade(white, 71);
      margin-bottom: 4px;
    }
    .subTitle {
      font-size: 16px;
    }
    .summaryTitle {
      font-size: 24px;
      font-weight: bold;
      line-height: 1;
      margin-bottom: 4px;
    }

    @media (max-width: 600px) {
      .title {
        font-size: 16px;
        text-transform: uppercase;
      }

      .subTitle {
        font-size: 14px;
      }

      .summaryTitle {
        font-size: 18px;
        font-weight: bold;
        line-height: 1;
      }

      .image {
        height: 170px;
      }
    }

    .centered {
      align-items: center;
    }
    .image {
      background-size: cover;
      background-position: center center;
      background-repeat: no-repeat;
      min-height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// PersonalizationPanel.vue?22d217ee